

interface CalcPerformanceProps {
  brokerSpeed: number // kts (the broker's stated speed)
  actualSpeed: number // kts (the real average speed)
  dailyFuelConsumption: number // mt/day
  dailyHireRate: number // USD/day
  fuelPrice: number // USD/mt
}

interface CalcPerformanceResult {
  timeDeltaDays: number // (+) means extra days needed, (-) means days saved
  fuelDeltaMt: number // (+) means extra fuel used, (-) means fuel saved
  costDeltaUSD: number // (+) means extra USD spent, (-) means USD saved
}

export function calcOverUnderPerformance({
  brokerSpeed,
  actualSpeed,
  dailyFuelConsumption,
  dailyHireRate,
  fuelPrice,
}: CalcPerformanceProps): CalcPerformanceResult {

  // 1) Broker’s claimed distance in 24h:
  const brokerDistanceNm = brokerSpeed * 24

  // 2) Actual time (in days) to cover the same distance:
  const actualTimeDays = brokerDistanceNm / actualSpeed / 24

  // 3) Time difference:
  //    positive => you're taking longer than broker’s claim
  //    negative => you're faster than broker’s claim
  const timeDeltaDays = actualTimeDays - 1

  // 4) Fuel difference:
  //    Broker scenario => 1 day of fuel
  //    Actual scenario => actualTimeDays of fuel
  const brokerFuelMt = dailyFuelConsumption * 1
  const actualFuelMt = dailyFuelConsumption * actualTimeDays
  const fuelDeltaMt = actualFuelMt - brokerFuelMt

  // 5) Cost difference:
  //    Summation of extra hire cost + extra fuel cost
  const extraHireCost = timeDeltaDays * dailyHireRate // can be +/-
  const extraFuelCost = fuelDeltaMt * fuelPrice // can be +/-
  const costDeltaUSD = extraHireCost + extraFuelCost

  return {
    timeDeltaDays,
    fuelDeltaMt,
    costDeltaUSD,
  }
}
